import React, { useEffect, useState } from "react";
import { SelectInput, TextInput } from "../../components/common/ui/Inputs";
import DateInput from "./../../components/common/ui/Inputs/DateInput";
import Button from "./../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import InmateIcon from "../../assets/green.png";
import AutoIcon from "../../assets/orange.png";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  inmateAction,
  masterActions,
  publicUserActions,
} from "../../_store";
import { useLocation } from "react-router-dom";
import {
  fDate,
  fDateTimeSuffix,
  formatDateTimeAMPM,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";
import generateXlsx from "../../components/common/export/generateXlsx";
import Openemail from "../../assets/svg/Read-Message.svg";
import email from "../../assets/svg/unread-icon-new.svg";
import QuarantineRejected from "../../assets/svg/Quarantine_rejected_msg.svg";
import QuarantinePending from "../../assets/svg/Quarantine_msg.svg";
import ReadDelete from "../../assets/svg/read-and-delete.svg";

import UnReadMsgDelete from "../../assets/svg/unread-message-delete.svg";

import MessageQuaratine from "../../assets/svg/Quarantine_msg.svg";

import ReadMessage from "../../assets/svg/Read-Message.svg";

import UnReadmail from "../../assets/svg/unread-icon-new.svg";

import RejectQuarantine from "../../assets/svg/Quarantine_rejected_msg.svg";
import CODPending from "../../assets/svg/cod_pending.svg";
import { findGraphemeClusters } from "../../components/common/ui/findGraphemeClusters";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";

function InmateMessage() {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { publicUserLastName, publicUserFirstName } = useSelector(
    (x) => x.master
  );

  const {
    inmateInfoTabData,
    PUMessageDataList,
    PUMessageDataFullList,
    loading,
    FacilityQuarantineBlockRes,
    inmate,
    intialMessageSearch
  } = useSelector((x) => x.inmate);

  const [isloading, setisloading] = useState(false);
  const { MessageAccessPermission, InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();

  const {
    user,
    commonFacilityCode: facilityCode,
    isDisabledInmate
  } = useSelector((x) => x.auth);
  const { Quarantineflag, Quarantineflagfull, direction } = useSelector(
    (x) => x.dropdownOptions
  );

  const dispatch = useDispatch();

  const initialMessageData = {
    ...intialMessageSearch,
    UserID: 0,
    UserFirstNameId: 0,
    UserLastNameId: 0,
    UserFirstName: "",
    UserLastName: "",
    MessageDirection: 0,
    MessageSendStartDate: getPastDate(6),
    MessageSendEndDate: getCurrentDate(),
    MessageFlag: 3,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "MessageID desc",
  };

  const [showSearchFields, setShowSearchFields] = useState(false);

  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;
    const updatedMessageData = {
      ...intialMessageSearch,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName,
      InmateLastName: Inmate?.LastName || inmate?.LastName,
    };

    dispatch(inmateAction.setinitialMessageSearch(updatedMessageData));
    setisloading(true);
    dispatch(inmateAction.LoadPUMessageSearch(updatedMessageData)).then((x) => {
      setisloading(false);
    })
  }, [Inmate || inmate]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
    const Inmate_Setting_Access = JSON.parse(process.env.REACT_APP_INMATE_SETTING);
    dispatch(authActions.updateisDisabledInmate(Inmate_Setting_Access.includes(user?.UserRoleID) ? false : true));
  }, [dispatch]);

  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    const facilityID = Inmate?.facilityID || inmate?.facilityID || facilityCode;
    const inmateID = Inmate?.InmateID || inmate?.InmateID;

    // Dispatch actions for public last name and first name
    dispatch(
      masterActions.GetPublicLastName({
        facilityID,
        firstName: "", // As per the existing logic, leaving firstName as empty string
        inmatesId: inmateID,
      })
    );
    if (intialMessageSearch?.UserLastNameId === 0 || intialMessageSearch?.UserLastNameId === undefined) {
      dispatch(
        masterActions.GetPublicFirstName({
          facilityID,
          lastName: "", // As per the existing logic, leaving lastName as empty string
          inmatesId: inmateID,
        })
      );
    }
    dispatch(
      inmateAction.LoadFacilityQuarantineBlock({
        facilityId: facilityID,
      })
    );
  }, [Inmate || inmate]);

  //Redirect
  const navigateMessage = (row) => {
    if (MessageAccessPermission[0]?.SubMenuActiveStatus === 0) {
      return;
    }
    dispatch(inmateAction.setInmateCurrentTab("inmate-message-tab"));
    // dispatch(inmateAction.LoadPUMessageIDList({ ...updatedSearch, RowCountPerPage: PUMessageDataList?.TotalRecordCount || 1000, PageNo: 1 })).then((result) => {
    let findIndex = PUMessageDataList?.DataList?.findIndex(x => x?.MessageID === row.MessageID);
    history.navigate("MessageList/Conversation", {
      state: {
        messageID: row.MessageID,
        source: "InmateMessage",
        Inmate: Inmate,
        index: findIndex ? findIndex : 0
      },
    });
    // })
  };

  const navigatePublicUser = (row) => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    // if (isDisabledInmate) return;
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "InmateMessage", Inmate: Inmate },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };

  const navigateInmateInfo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    // if (isDisabledInmate) return;
    history.navigate("InmateList/Details", {
      state: { inmate: Inmate, source: "InmateMessage" },
    });
    dispatch(inmateAction?.setInmateCurrentTab("inmate-info-tab"));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const columns = [
    {
      name: "Subject",
      key: "MessageSubject",
      selector: (row) => row.FullMessageSubject,
      cell: (row) => (
        <div
          onClick={() => navigateMessage(row)}
          className={` ${MessageAccessPermission[0]?.SubMenuActiveStatus !== 0
            ? "Common_Link_Style"
            : ""
            }`}
        >
          {/* {row.FullMessageSubject} */}
          {findGraphemeClusters(row.FullMessageSubject, false)?.length > 15
            ? findGraphemeClusters(row.FullMessageSubject, true)
            : row.FullMessageSubject}
        </div>
      ),
      sortable: true,
    },
    {
      width: '120px',
      name: "From",
      key: "MessageFrom",
      selector: (row) => row.MessageFrom,
      cell: (row) => (
        <div
          onClick={
            row?.Sender === "PublicUser"
              ? () => navigatePublicUser(row)
              : () => navigateInmateInfo(row)
          }
          className={`d-flex gap-2 align-items-center 
  ${row?.Sender === "PublicUser"
              ? ((PuAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : "")
              : ((InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : "")
            }`}

        >
          <div
            className={
              row?.Sender === "PublicUser"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          {row.MessageFrom}
        </div>
      ),
      sortable: true,
    },
    {
      width: '120px',
      name: "To",
      key: "MessageTo",
      selector: (row) => row.MessageTo,
      cell: (row) => (
        <div
          onClick={
            row?.Receiver === "Inmate"
              ? () => navigateInmateInfo(row)
              : () => navigatePublicUser(row)
          }
          className={`d-flex gap-2 align-items-center 
  ${row?.Receiver === "Inmate"
              ? ((InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : "")
              : ((PuAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : "")
            }`}

        >
          <div
            className={
              row?.Sender === "Inmate"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          {row.MessageTo}
        </div>
      ),
      sortable: true,
    },
    {
      width: "140px",
      name: "Message Cost ($)",
      key: "MessageCost",
      selector: (row) => row.MessageCost.toFixed(2), // Format to 2 decimal places
      sortable: true,
    },
    {
      name: "Mode of Payment",
      key: "MessagePaymentSource",
      selector: (row) => row.ModeOfPayment,
      sortable: true,
    },
    {
      width: "60px",
      name: "Flag",
      key: "MessageFlag",
      selector: (row) => row.MessageFlag,
      sortable: true,
      cell: (row) =>
        row?.MessageFlag === 2 || row?.MessageFlag === 1 ? (
          <i
            className="fa fa-flag flagged-message fs-2"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ) : (
          <i
            className="fa fa-flag non-flagged-message fs-2"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ),
    },
    {
      name: "Sent",
      key: "MessageSentDate",
      // selector: (row) => formatDate(row.MessageSentDate),
      selector: (row) => formatDateTimeAMPM(row.MessageSentDate),
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDateTimeAMPM(row?.MessageSentDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Read",
      key: "MessageReceiveDate",
      selector: (row) => formatDateTimeAMPM(row.MessageReceiveDate),
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {/* {formatDateTimeAMPM(row?.MessageReceiveDate)} */}
            {(row?.MessageReceiveDate == "0001-01-01T00:00:00" || row?.ModeOfPayment == "COD") ? "-" : formatDateTimeAMPM(row.MessageReceiveDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "MessageStatus",
      selector: (row) => row.MessageStatus,
      sortable: true,
      cell: (row) =>
        row?.MessageStatus === "Read" && row?.IsReceiverMsgDelete === 1 ? (
          <div title="Read & Message Deleted">
            <img alt="status" src={ReadDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" &&
          row?.IsReceiverMsgDelete === 1 ? (
          <div title="Unread & Message Deleted">
            <img alt="status" src={UnReadMsgDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Read" ? (
          <div title="Read">
            <img alt="status" src={ReadMessage} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" ? (
          <div title="Unread">
            <img
              alt="status"
              src={UnReadmail}
              style={{ height: "30px", width: "30px" }}
              title="Unread"
            />
          </div>
        ) : row?.MessageStatus === "Pending Quarantine Approval" ? (
          <div title="Quarantine Message">
            <img alt="status" src={MessageQuaratine} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Reject Quarantine" ? (
          <div title="Quarantine Rejected">
            <img alt="status" src={RejectQuarantine} className="msg-icon" />
          </div>
        ) : (
          <div title="C.O.D Pending">
            <img alt="status" src={CODPending} className="msg-icon" />
          </div>
        ),
      center: true,
    },
  ];

  const handlePageChange = (pageNo) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    dispatch(inmateAction.setinitialMessageSearch({ ...intialMessageSearch, PageNo: pageNo }));
    dispatch(inmateAction.LoadPUMessageSearch({ ...intialMessageSearch, PageNo: pageNo, }));
  };

  const handleRowPerPage = (rowPerPage) => {
    dispatch(inmateAction.setinitialMessageSearch({ ...intialMessageSearch, PageNo: 1, RowCountPerPage: rowPerPage }));
    dispatch(inmateAction.LoadPUMessageSearch({ ...intialMessageSearch, PageNo: 1, RowCountPerPage: rowPerPage, }));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;
    const search = { ...intialMessageSearch };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(inmateAction.setinitialMessageSearch(search));
    dispatch(
      inmateAction.LoadPUMessageSearch({
        ...intialMessageSearch,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  let updatedSearch = { ...intialMessageSearch };

  const handleSelectChange = (selectedOption, name) => {
    const LoadPUGridList = () => {
      updatedSearch.PageNo = 1;
      updatedSearch.RowCountPerPage = 10;
      updatedSearch.SortField = "MessageID desc";
      dispatch(inmateAction.LoadPUMessageSearch(updatedSearch));
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserFirstNameId = selectedOption?.value || 0;

      // dispatch(
      //   masterActions.GetPublicLastName({
      //     facilityID: updatedSearch.FacilityID,
      //     firstName: updatedSearch.UserFirstName,
      //     inmatesId: updatedSearch.InmateID,
      //   })
      // );

      LoadPUGridList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserLastNameId = selectedOption?.value || 0;

      updatedSearch.UserFirstName = "";
      updatedSearch.UserFirstNameId = 0;

      dispatch(
        masterActions.GetPublicFirstName({
          facilityID: updatedSearch.FacilityID,
          lastName: updatedSearch.UserLastName,
          inmatesId: updatedSearch.InmateID,
        })
      );

      LoadPUGridList();
    };

    switch (name) {
      case "UserLastName":
        handleLastName();
        break;

      case "UserFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] =
          name === "MessageFlag"
            ? selectedOption?.value ?? 3
            : selectedOption?.value ?? 0;
        LoadPUGridList();
        break;
    }
    dispatch(inmateAction.setinitialMessageSearch(updatedSearch));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    updatedSearch[name] = date;
    dispatch(inmateAction.setinitialMessageSearch(updatedSearch));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "MessageSendStartDate") {
      if (
        updatedSearch.MessageSendEndDate &&
        new Date(value) > new Date(updatedSearch.MessageSendEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "MessageSendEndDate") {
      if (
        updatedSearch.MessageSendStartDate &&
        new Date(value) < new Date(updatedSearch.MessageSendStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      MessageSendStartDate:
        fieldName === "MessageSendStartDate"
          ? isFromValid && isValidDate
            ? value
            : getPastDate(6)
          : updatedSearch.MessageSendStartDate, // preserve existing value
      MessageSendEndDate:
        fieldName === "MessageSendEndDate"
          ? isToValid && isValidDate
            ? value
            : getCurrentDate()
          : updatedSearch.MessageSendEndDate, // preserve existing value
    };
    dispatch(inmateAction.setinitialMessageSearch(updatedParam));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // If validation passes, proceed with form submission

    const updatedSearchOnSubmit = {
      ...updatedSearch,
      PageNo: 1,
      RowCountPerPage: 10
    };
    dispatch(inmateAction.setinitialMessageSearch(updatedSearchOnSubmit));
    setisloading(true);
    dispatch(inmateAction.LoadPUMessageSearch(updatedSearchOnSubmit)).then((x) => { setisloading(false); })
  };

  const handleReset = () => {
    dispatch(inmateAction.setinitialMessageSearch(initialMessageData));
    setisloading(true);
    dispatch(inmateAction.LoadPUMessageSearch(initialMessageData)).then((x) => { setisloading(false); })
    dispatch(
      masterActions.GetPublicFirstName({
        facilityID: updatedSearch.FacilityID,
        lastName: "",
        inmatesId: updatedSearch.InmateID,
      })
    );
  };

  //Excel

  useEffect(() => {
    if (PUMessageDataFullList && PUMessageDataFullList?.DataList?.length > 0) {
      let title = "Messages_List";
      let generateExcelColumns = [
        "Subject",
        "From",
        "To",
        "Message Cost($)",
        "Flag",
        "Sent",
        "Read",
        "Status",
        "Source Of Pay",
        "Amount Debited On",
        "Is COD Message",
        "Mode Of Payment",
        "COD Status",
        "Approved/Rejected By",
        "User Type",
      ];

      // Map the account manager list to match the Excel format
      let PUMessage_List =
        PUMessageDataFullList?.DataList?.map((obj) => ({
          Subject: obj.FullMessageSubject,
          From: obj.MessageFrom,
          To: obj.MessageTo,
          MessageCost: obj.MessageCost.toFixed(2),
          Flag: obj.MessageBothFlagKeyWords,
          // MessageFlag

          Sent: formatDateTimeAMPM(obj.MessageSentDate) || "-",
          // Read: formatDateTimeAMPM(obj.MessageReceiveDate) || "-",
          Read: (obj?.MessageReceiveDate == "0001-01-01T00:00:00" || obj?.ModeOfPayment == "COD") ? "-" : formatDateTimeAMPM(obj.MessageReceiveDate),
          Status:
            (obj?.MessageStatus === "Read" && obj?.IsReceiverMsgDelete == 1) ? "Read & Message Deleted" :
              (obj?.MessageStatus === "Unread" && obj?.IsReceiverMsgDelete === 1) ? "Unread & Message Deleted" :
                obj?.MessageStatus === "Read" ? "Read" :
                  obj?.MessageStatus === "Unread" ? "Unread" :
                    obj?.MessageStatus === "Pending Quarantine Approval" ? "Quarantine Message" :
                      obj?.MessageStatus === "Reject Quarantine" ? "Quarantine Rejected" :
                        "C.O.D Pending",
          Source: obj.MessagePaymentSource,
          AmountDebitedOn: formatDateTimeAMPM(obj.DebitAmountDate) || "-",
          IsCODMessage: obj.IsCODMessage,
          ModeOfPayment: obj.ModeOfPayment,
          CODStatus: obj.CODStatus,
          ApprovedRejectedBy: obj.ApproveOrRejectedBy,
          UserType: obj.UserType,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(PUMessage_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearPUdataList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [PUMessageDataFullList]);

  const handleExcel = () => {
    let updatedParam = {
      ...intialMessageSearch,
      PageNo: 1,
      RowCountPerPage: PUMessageDataList.TotalRecordCount,
      // SortField: "MessageID desc",
      exportExcel: true, // Flag to indicate Excel export
    };

    dispatch(inmateAction.LoadPUMessageSearch(updatedParam));
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Username, Last Name, First Name */}
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            {/* Frequency */}
            <div className="col-sm-12 col-md-4 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate Last Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.LastName ||
                  inmate?.LastName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.LastName)}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-sm-12 col-md-4 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.FirstName ||
                  inmate?.FirstName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)}
              </strong>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={publicUserLastName}
                value={intialMessageSearch?.UserLastNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={intialMessageSearch?.UserLastNameId !== 0}
                placeholder="Select Last Name"
                label="Public User Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={publicUserFirstName}
                value={intialMessageSearch?.UserFirstNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={intialMessageSearch?.UserFirstNameId !== 0}
                placeholder="Select First Name"
                label="Public User First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              {/* Connection */}
              <SelectInput
                options={direction}
                value={intialMessageSearch?.MessageDirection} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "MessageDirection")
                }
                placeholder="Select Direction"
                label="Direction"
                isClearable={intialMessageSearch?.MessageDirection !== 0}
              />
            </div>
          </div>

          {/* Third Row: Phone Number, From Date, To Date */}

          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <DateInput
                value={intialMessageSearch?.MessageSendStartDate}
                handleChange={(e) =>
                  handleDateChange(e, "MessageSendStartDate")
                }
                name="MessageSendStartDate"
                label={"From Date"}
                maxDate={
                  intialMessageSearch?.MessageSendEndDate
                    ? intialMessageSearch?.MessageSendEndDate
                    : new Date()
                }
                required={false}
                isClearable={false}
                // preventClear={true}
                disabled={false}
                yearDropDown={true}
                monthDropDown={false}
                className={false ? "disabled-date-input" : ""} // Add class conditionally
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "MessageSendStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "MessageSendStartDate")
                }
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              <DateInput
                value={intialMessageSearch?.MessageSendEndDate}
                handleChange={(e) => handleDateChange(e, "MessageSendEndDate")}
                name="MessageSendEndDate"
                minDate={
                  intialMessageSearch?.MessageSendStartDate
                    ? intialMessageSearch?.MessageSendStartDate
                    : new Date(2017, 0, 1)
                }
                label={"To Date"}
                maxDate={new Date()}
                required={false}
                disabled={false}
                isClearable={false}
                // preventClear={true}
                yearDropDown={true}
                monthDropDown={false}
                handleBlur={(e) => handleDateBlur(e, "MessageSendEndDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "MessageSendEndDate")
                }
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-lg-4 col-md-6">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={
                  FacilityQuarantineBlockRes &&
                    FacilityQuarantineBlockRes[0]?.IsQuarantineWordBlock > 0
                    ? Quarantineflagfull
                    : Quarantineflag
                }
                value={intialMessageSearch?.MessageFlag} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "MessageFlag")
                }
                isClearable={intialMessageSearch?.MessageFlag !== 3}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select Status"
                label={"Flag"}
              />
            </div>
          </div>

          {/* Fourth Row: Connection, Status */}
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            // variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset} // This will now work correctly
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };
  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i class="fa fa-comment me-2"></i>Messages
          </h4>
          <Button
            label="Back"
            type="button"
            icon={"fa-solid fa-angle-left"}
            status="primary"
            onClick={() => {
              dispatch(inmateAction.clearInmate());
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
              history.navigate("/Admin/InmateList");
            }}
          />
        </div>
      </div>

      <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
        {/* <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className=" text-color form_title_uppercase">search</h2>
        </div> */}

        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">SEARCH</h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          {/* Icons and Export Button */}
          <div className="d-flex flex-wrap gap-4">
            {PUMessageDataList?.DataList?.length > 0 && (
              <div className="d-flex flex-wrap  align-items-center gap-1">
                {/* Left Side: Icons */}
                <div className={"user-batch button-success"}></div>

                <div className="text fs-5">Public User</div>
              </div>
            )}
            {PUMessageDataList?.DataList?.length > 0 && (
              <div className="d-flex flex-wrap align-items-center gap-1">
                <div className={"user-batch button-primary"}></div>
                <div className="text fs-5">Inmate</div>
              </div>
            )}
            {PUMessageDataList?.DataList?.length > 0 && (
              <div className="d-flex flex-wrap align-items-center gap-1">
                <i
                  className="fa fa-flag flagged-message"
                  aria-hidden="true"
                ></i>
                <div className="text fs-5">Flagged Message</div>
              </div>
            )}
            {PUMessageDataList?.DataList?.length > 0 && (
              <div className="d-flex flex-wrap align-items-center gap-1">
                <i
                  className="fa fa-flag non-flagged-message"
                  aria-hidden="true"
                ></i>
                <div className="text fs-5">Non Flagged Message</div>
              </div>
            )}
          </div>
          {/* Right Side: Export Button */}
          {PUMessageDataList?.DataList?.length > 0 && (
            <div className="d-flex flex-wrap gap-3 align-items-center">
              <ExcelExport handleExcelExport={handleExcel} />
            </div>
          )}
        </div>

        {/* Table Section */}

        <Table
          columns={columns}
          data={PUMessageDataList?.DataList}
          pagination={true}
          onChangePage={(e) => handlePageChange(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          totalRowCount={PUMessageDataList?.TotalRecordCount}
          currentPage={intialMessageSearch?.PageNo}
          paginationPerPage={intialMessageSearch?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={intialMessageSearch?.SortField?.split(" ")[0]}
          sortDirection={intialMessageSearch?.SortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(InmateMessage);
